import Vue from 'vue'
import signingProviderApi from '@/api/signingProvider.api'

const state = {
  providers: {}
}


const getters = {
  signingProviders: (state) => {
    return Object.values(state.providers) || []
  },

  signingProviderById: (state) => (id) => {
    return state.providers[id] || null
  }
}


const actions = {
  async loadSigningProviders ({ commit, rootState }) {
    const response = await signingProviderApi.getProviders(rootState.tenant.current)
    commit('SET_PROVIDERS', response.data)
  }
}


const mutations = {
  SET_PROVIDERS (state, providers) {
    state.providers = {}

    for (const provider of providers) {
      Vue.set(state.providers, provider.id, provider)
    }
  }
}


export default {
  state,
  getters,
  actions,
  mutations
}
